<div class="nav">
    <ul class="nav nav-pills nav-fill fixed-bottom px-1 py-2 d-flex justify-content-center">
        <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 1" (click)="navigateToTab(1)">
                <i class="bi bi-plus-circle"></i>
                <span class="tab-title">
                    {{ 'notification.create_message' | translate }}
                </span>
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 2" (click)="navigateToTab(2)">
                <i class="bi bi-plus-circle"></i>
                <span class="tab-title">
                    {{ 'notification.create_email' | translate }}
                </span>
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 3" (click)="navigateToTab(3)">
                <i class="bi bi-send"></i>
                <span class="tab-title">
                    {{ 'notification.sent_message_list' | translate }}
                </span>
            </a>
        </li>
    </ul>
</div>
<div class="container" (swipe)="onSwipe($event)">
    <div class="tab-content">
        <div *ngIf="activeTab === 1">
            <div class="mt-0 p-0 p-xl-5 row bg-light border-top border-dark">
                <app-notification-create></app-notification-create>
            </div>
        </div>
        <div *ngIf="activeTab === 2">
            <div class="mt-0 p-0 p-xl-5 row bg-light border-top border-dark">
                <app-notification-create-email></app-notification-create-email>
            </div>
        </div>
        <div *ngIf="activeTab === 3">
            <div class="mt-0 p-0 p-xl-5 row bg-light border-top border-dark">
                <app-notification-sent-message-list></app-notification-sent-message-list>
            </div>
        </div>
    </div>
</div>
